<template>
  <div class="flex1" v-if="Object.keys(islKey).length > 0">
    <div class="row mb-3">
      <div class="col-12">
        <h1>{{ islKey.key }}</h1>
          <div class="row desc-row">
            <div class="col-md-3 col-12 center-para bordered">
            <input
              v-if="isEditing(islKey.id, 'desc')"
              :id="`edit-islKey-${islKey.id}`"
              :value="islKey.desc"
              type="text"
              class="textarea"
              placeholder="Description"
            />
            <span v-else>
              {{ islKey.desc }}
            </span>
            </div>
            <div class="col-md-2 col-12 center-para">
              <div v-if="isEditing(islKey.id, 'desc')">
              <button
                class="btn btn-sm btn-success mx-1"
                @click="editDescription(islKey.id);"
              >
                Save
              </button>
              <button
                class="btn btn-sm btn-secondary mx-1"
                @click="cancelEdit(islKey.id, 'desc');"
              >
                Cancel
              </button>
              </div>
              <button
                v-else
                class="btn btn-sm btn-info mx-1"
                @click="activateEdit(islKey.id, 'desc');"
              >
                Edit
              </button>
            </div>  
          </div>
      </div>
    </div>
    <div class="row titles">
      <div class="col-md-2 col-12">Audience</div>
      <div class="col-md-1 col-12">Priority</div>
      <div class="col-md-9 col-12">
        <div class="row">
          <div class="col-md-3 col-12">Language</div>
          <div class="col-md-7 col-12">Value</div>
          <div class="col-md-2 col-12"></div>
        </div>
      </div>
    </div>
   <div class="row mt-4">
      <div class="col-md-2 col-12">
        <select v-model="newValue.audience" class="form-control">
          <option disabled value="">Please select an operator</option>
          <option value="default">Default</option>
          <option
            v-for="audience in audiences"
            :key="'opSelect-' + audience.name"
            :value="audience.id"
          >
            {{ audience.name }}
          </option>
        </select>
      </div>
      <div class="col-md-1">
        <input
          class="form-control"
          type="text"
          v-model="newValue.priority"
          placeholder="Priority"
        />
      </div>
      <div class="col-md-9 col-12">
        <div class="row">
          <div class="col-md-3 col-12">
            <select v-model="newValue.language" class="form-control">
              <option disabled value="">Please select a language</option>
              <option
                v-for="language in languageOptions"
                :key="'typeSelect-' + language.code"
                :value="language.code"
              >
                {{ language.name }}
              </option>
            </select>
          </div>
          <div class="col-md-7 col-12">
            <input
              class="form-control"
              type="text"
              v-model="newValue.value"
              placeholder="New Value"
            />
          </div>
          <div class="col-md-2 col-12">
            <button class="btn btn-sm btn-success mx-2 action-button" @click="addNewValue()">
              ADD
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr class="dashed">
    <div
      class="row"
      v-for="(type, typeKey) in types"
      :key="`islKey-${typeKey}`"
    >
      <div class="col-md-12" v-if="typeKey == 'default_values'">
        <div class="row mx-0">
          <div class="col-md-2 col-12 white-borders">
            <h4 class="center-para">Default</h4>
          </div>
          <div class="col-md-1 col-12 white-borders text-center">
            <p>-</p>
          </div>
          <div class="col-md-9 col-12">
            <div
              class="row"
              v-for="(langValue, langKey) in islKey[typeKey]"
              :key="`islKey-audience-${langKey}`"
            >
              <div class="col-md-3 col-12 white-borders">
                {{ findLanguageByCode(langKey) }}
              </div>
              <div class="col-md-7 col-12 white-borders">
                <div v-if="isEditing('default', langKey)" style="width: 100%">
                  <textarea
                    class="textarea"
                    type="text"
                    :value="langValue"
                    :id="`edit-value-default-${langKey}`"
                    v-on:keyup="textAreaAdjust(`edit-value-default-${langKey}`);"
                    @click="textAreaAdjust(`edit-value-default-${langKey}`);"
                  />
                </div>
                <div class="lang-value" v-else>
                  {{ langValue }}
                </div>
              </div>
        <div class="col-md-2 col-12 center-para">
          <div v-if="isEditing('default', langKey)">
            <div class="row">
          <button
          class="btn btn-sm btn-success mx-2 action-button"
          @click="editValue('default', langKey)"
        >
          Save
        </button>
        <button
            class="btn btn-sm btn-secondary mx-2 action-button"
            @click="cancelEdit('default', langKey);"
          >
            Cancel
        </button>
            </div>
        </div>
        <div v-else>
          <div class="row"> 
            <button
              class="btn btn-sm btn-info mx-2 action-button"
              @click="activateEdit('default', langKey)"
            >
              Edit
          </button>
          <button
            class="btn btn-sm btn-danger mx-2 action-button"
            @click="deleteConditionalValue('default', langKey)"
          >
            Del
          </button>
        </div>
        </div>
      </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12" v-else>
        <div
          class="row mx-0"
          v-for="(audienceValue, audienceKey) in islKey[typeKey]"
          :key="`islKey-audience-${audienceKey}`"
        >
          <div class="col-md-2 col-12 white-borders">
            <div v-if="isEditing(audienceKey, '')">
              <select v-model="audienceEdit" class="form-control" style="margin-top: 5px">
                <option disabled value="">Please select an audience</option>
                <option value="default">Default</option>
                <option
                  v-for="audience in audiences"
                  :key="'opSelect-' + audience.name"
                  :value="audience.id"
                >
                  {{ audience.name }}
                </option>
              </select>
              <div class="row d-flex justify-content-center" style="margin-top: 5px">
                <button class="btn btn-sm btn-success mx-2 action-button" @click="editAudienceName(audienceKey, '')">Save</button>
                <button class="btn btn-sm btn-secondary mx-2 action-button" @click="cancelEdit(audienceKey, '')">Cancel</button>
              </div>
            </div>
            <div v-else>
              <h4 class="center-para">{{ audience(audienceKey).name }}</h4>
            </div>
            <button class="far fa-edit editIcon" @click="activateEdit(audienceKey, '')" v-if="!isEditing(audienceKey, '')"></button>
          </div>
          <div class="col-md-1 col-12 white-borders">
            <input
              class="form-control"
              type="number"
              :value="audienceValue.priority"
              :id="audienceKey + '-priority'"
              @change="changePriority(audienceKey)"
            />
          </div>
          <div class="col-md-9 col-12">
            <div
              class="row"
              v-for="(langValue, langKey) in audienceValue"
              :key="`islKey-audience-lang-${langKey}`"
            >
              <template v-if="langKey != 'priority'">
                <div class="col-md-3 col-12 white-borders">
                  {{ findLanguageByCode(langKey) }}
                </div>
                <div class="col-md-7 col-12 white-borders">
                  <div
                    v-if="isEditing(audienceKey, langKey)"
                    style="width: 100%"
                  >
                    <textarea
                      class="textarea"
                      type="text"
                      :value="langValue"
                      :id="`edit-value-${audienceKey}-${langKey}`"
                      v-on:keyup="textAreaAdjust(`edit-value-${audienceKey}-${langKey}`);"
                      @click="textAreaAdjust(`edit-value-${audienceKey}-${langKey}`);"
                    />
                  </div>
                  <div class="lang-value" v-else>
                    {{ langValue }}
                  </div>
                </div>
          <div class="col-md-2 col-12 center-para">
          <div class="row" v-if="isEditing(audienceKey, langKey)">
          <button
          class="btn btn-sm btn-success mx-2 action-button"
          @click="editValue(audienceKey, langKey)"
        >
          Save
        </button>
        <button
            class="btn btn-sm btn-secondary mx-2 action-button"
            @click="cancelEdit(audienceKey, langKey);"
          >
            Cancel
        </button>
        </div>
        <div v-else>
          <div class="row">
                     <button
          class="btn btn-sm btn-info mx-2 action-button"
          @click="activateEdit(audienceKey, langKey)"
        >
          Edit
        </button>
        <button
          class="btn btn-sm btn-danger mx-2 action-button"
          @click="deleteConditionalValue(audienceKey, langKey)"
        >
          Del
        </button>
          </div>

        </div>
      </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      types: { default_values: "Default", audience_values: "Audience Values" },
      newValue: {},
      editingValues: [],
      audienceEdit : " "
    };
  },
  computed: {
    islKey() {
      const islKeys = this.$store.getters.islKeys;
      if (islKeys.length > 0) {
        const islKey = islKeys.find((el) => el.id == this.$route.params.id);
        if (islKey) {
          return islKey;
        }
      }
      return {};
    },
    audiences() {
      const audiences = this.$store.getters.audiences;
      if (audiences) return audiences;
      else return [];
    },
    languageOptions() {
      const audienceOptions = this.$store.getters.audienceOptions;
      if (audienceOptions) {
        const languageKey = audienceOptions.find(
          (item) => item.key == "language"
        );
        if (languageKey) {
          return languageKey.options;
        } else {
          return [];
        }
      } else {
        return [];
      }
      if (conditionTypes.language) return conditionTypes.language.options;
      else return [];
    },
  },
  methods: {
      textAreaAdjust(id) {
      const element = document.getElementById(id)
        element.style.height = 'auto';        
        element.style.height = (element.scrollHeight) + 'px';
      },
      renameKey ( obj, oldKey, newKey ) {
        obj[newKey] = obj[oldKey];
        delete obj[oldKey];
      },
      editAudienceName(audienceKey,langKey){
        const data = JSON.parse(JSON.stringify(this.islKey));
        const id = data.id
        delete data.id;
        const newValue = this.audienceEdit
        this.renameKey(data.audience_values, audienceKey, newValue)
        this.$store.dispatch("configEdit", {
          type: "isl",
          payload: { id, data},
        });
        this.editingValues = this.editingValues.filter((item) => item != `${audienceKey}-${langKey}`);
      },
      cancelEdit(id, key){
        this.editingValues = this.editingValues.filter((item) => item != `${id}-${key}`);
      },
      editDescription(id) {
      const data = JSON.parse(JSON.stringify(this.islKey));
      delete data.id;
      data.desc = document.getElementById(`edit-islKey-${id}`).value;
      this.$store.dispatch("configEdit", {
        type: "isl",
        payload: { id, data},
      });
        this.editingValues = this.editingValues.filter((item) => item != `${id}-desc`);
    },
    addNewValue() {
      if (this.newValue.audience && this.newValue.language) {
        const data = JSON.parse(JSON.stringify(this.islKey));
        const id = data.id;
        delete data.id;
        if (this.newValue.audience == "default") {
          this.defineIfUndefined(data, "default_values");
          data.default_values[this.newValue.language] = this.newValue.value;
        } else {
          this.defineIfUndefined(data, "audience_values");
          this.defineIfUndefined(data.audience_values, this.newValue.audience);
          data.audience_values[this.newValue.audience][this.newValue.language] =
            this.newValue.value;
          if (this.newValue.priority && Number(this.newValue.priority)) {
            if (!data.priorities) data.priorities = {};
            data.audience_values[this.newValue.audience].priority =
              this.newValue.priority;
          }
        }

        this.$store.dispatch("configEdit", {
          type: "isl",
          payload: { id, data },
        });
        this.newValue = {};
      } else {
        return;
      }
    },
    deleteConditionalValue(audienceId, languageKey) {
      if (
        confirm(
          `You are trying to delete "${
            this.audience(audienceId).name +
            " " +
            this.findLanguageByCode(languageKey)
          }" key. Are you sure?`
        )
      ) {
        const data = JSON.parse(JSON.stringify(this.islKey));
        const id = data.id;
        delete data.id;
        if (audienceId == "default") {
          delete data.default_values[languageKey];
        } else {
          delete data.audience_values[audienceId][languageKey];
          if (
            Object.keys(
              Object.keys(data.audience_values[audienceId]).filter(
                (item) => item != "priority"
              )
            ).length === 0
          ) {
            delete data.audience_values[audienceId];
          }
        }
        this.$store.dispatch("configEdit", {
          type: "isl",
          payload: { id, data },
        });
        this.newValue = {};
      }
    },
    audience(key) {
      const audience = this.audiences.find((item) => item.id == key);
      return audience ? audience : {};
    },
    findLanguageByCode(code) {
      const language = this.languageOptions.find(
        (item) => item.code.toLowerCase() == code.toLowerCase()
      );
      if (language) return language.name;
      else return code;
    },
    defineIfUndefined(obj, key) {
      if (obj[key] == undefined) obj[key] = {};
    },
    changePriority(audience) {
      const value = Number(
        document.getElementById(audience + "-priority").value
      );
      if (Number.isInteger(value)) {
        const data = JSON.parse(JSON.stringify(this.islKey));
        const id = data.id;
        delete data.id;
        data.audience_values[audience].priority = value;
        this.$store.dispatch("configEdit", {
          type: "isl",
          payload: { id, data },
        });
      }
    },
    activateEdit(audienceKey, langKey) {
    const experiments = this.$store.getters.experiments;
    if(experiments){
      const includedExperiments = experiments.filter(experiment => {
      return ((experiment.status == "started" || experiment.status == "created") && experiment.isls.includes(this.islKey.key))
      })
      if (includedExperiments.length > 0) {
        let experimentNames = ""
        includedExperiments.forEach( experiment => {
          experimentNames += experiment.name + ", "
        })
        experimentNames = experimentNames.slice(0, -2)
        if(confirm(`You will edit an isl key that is actively used in ${experimentNames} experiment/s, it may break the experiment. Are you sure?`)) {
          this.editingValues.push(audienceKey + "-" + langKey)
        }
        else return ;
      }
      else{
        this.editingValues.push(audienceKey + "-" + langKey)
      }
    }
    else{
      this.editingValues.push(audienceKey + "-" + langKey)
    }
    },
    isEditing(audienceKey, langKey) {
      return this.editingValues.indexOf(audienceKey + "-" + langKey) >= 0;
    },
    editValue(audienceKey, langKey) {
      const newValue = document.getElementById(
        `edit-value-${audienceKey}-${langKey}`
      ).value;
      if (newValue) {
        const data = JSON.parse(JSON.stringify(this.islKey));
        const id = data.id;
        delete data.id;
        if (audienceKey == "default") {
          this.defineIfUndefined(data, "default_values");
          data.default_values[langKey] = newValue;
        } else {
          this.defineIfUndefined(data, "audience_values");
          this.defineIfUndefined(data.audience_values, audienceKey);
          data.audience_values[audienceKey][langKey] = newValue;
        }
        this.$store.dispatch("configEdit", {
          type: "isl",
          payload: { id, data },
        });
        this.editingValues = this.editingValues.filter(
          (item) => item != audienceKey + "-" + langKey
        );
      } else {
        return;
      }
    },
  },
};
</script>

<style>

.flex1 {
  color: rgba(255, 255, 255, 0.8);
}
h1,
h4 {
  margin: 0;
}

.white-borders {
  border: 1px solid rgba(255, 255, 255, 0.6);
  align-content: center;
  align-items: center;
  display: flex;
  min-height: 40px;
}

.titles {
  color: #778ca3;
  font-size: 24px;
  line-height: 50px;
}

.action-button {
  padding: 5px 10px;
}

.editIcon{
  padding: 1%;
  background-color:#4e32a8;
  color: white;
  border-radius: 5px;
  float: right;
  margin-right: 5px;
}

</style>
